import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'gmAdderChange';
const word = 'new GM Adder cost';

export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			successMessage: `The ${word} was created successfully.
				Refresh to see the new value in the list or the formula page.`,
			onSuccessRedirectTo: `/formulas/gmAdderChanges`,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	let gmAdderChanges;

	const canRwGmAdder = !!_.get(state.auth.authUser, ['permissions', 'canRwPlc'], false);

	if (state.lists.gmAdderChangeIds) {
		gmAdderChanges = _.map(state.lists.gmAdderChangeIds, (id) => state.maps.gmAdderChange[id]);
	}
	return {
		canRwGmAdder,
		gmAdderChanges,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			gmAdderChangeSearch: search,
			gmAdderChangeAdd: add,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
